import React from "react";
import CommonFilterStructure from "../../../components/common-components/CommonFilterStructure";

const GlobalCardFilters = ({
  user,
  allFilters,
  setAllFilters,
  onClickReset,
  isSearchbar,
  onClickSearch,
  searchFilterApplied,
  isURE,
  isGlobal,
  isTop,
  isReload
}) => {
  return (
    <CommonFilterStructure
      from={"dashboard-cards"}
      decryptedText={user}
      setFilters={setAllFilters}
      filters={allFilters}
      onClickReset={onClickReset}
      isSearchbar={isSearchbar}
      onClickSearch={onClickSearch}
      searchFilterApplied={searchFilterApplied}
      isURE={isURE}
      isGlobal={isGlobal}
      otherUserLabel={"Added By"}
      isTop={isTop}
      isReload={isReload}
    />
  );
};

export default GlobalCardFilters;
